<style scoped>
    .EditableQuizBtn {
        margin: 0px 10px 30px 10px;
    }
</style>
<template>
    <div>
        <ul class="list-unstyled">
            <li
                    v-for="(q, i) in quizzes"
                    :key="i">
                <editable-quiz
                        :quiz="q"
                        :number="i"></editable-quiz><br>

            </li>
        </ul>

        <!--<draggable v-model="quizzes">-->
            <!--<transition-group>-->
                <!--<div v-for="(q, i) in quizzes" :key="i">-->
                    <!--<editable-quiz-->
                            <!--:quiz="q"-->
                            <!--:number="i"></editable-quiz><br>-->
                <!--</div>-->
            <!--</transition-group>-->
        <!--</draggable>-->

        <b-btn class="EditableQuizBtn"
               variant="primary"
               @click="addQuiz('quiz')">
            퀴즈 추가
        </b-btn>
        <b-btn class="EditableQuizBtn"
               variant="primary"
               @click="addQuiz('quizX10')">
            퀴즈 추가 X 10
        </b-btn>
        <b-btn class="EditableQuizBtn"
               variant="success"
               @click="addQuiz('custom')">
            커스텀 추가
        </b-btn>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import l from '@/vendor/logger'
import EditableQuiz from './EditableQuiz'
import QuizzesItem from '@/components/quizzes/QuizzesItem'
import draggable from 'vuedraggable'

export default {
  name: 'EditableQuizzes',
  created () {
    this.$store.dispatch('quizbank/bindQuiz')
  },
  beforeDestory () {
    this.$store.dispatch('quizbank/unbindQuiz')
  },

  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('quizbank/unbindQuiz')
    next()
  },
  methods: {
    addQuiz (type) {
      if (type === 'quiz') {
        this.$store.dispatch('quizbank/addQuiz', {
          type,
          question: 'q',
          selection: ['s 0', 's 1', 's 2'],
          answer: 0
        })
      } else if (type === 'quizX10') {
        this.$store.dispatch('quizbank/addQuizX10', {
          type: 'quiz',
          question: 'q',
          selection: ['s 0', 's 1', 's 2'],
          answer: 0
        })
      } else if (type === 'custom') {
        this.$store.dispatch('quizbank/addQuiz', {
          type,
          title: 'title',
          value: 'value',
          answer: 0
        })
      }
    },
    linkedQuizzes () {
      const linkedQuizzes = []
      // let firstQuiz
      let lastQuiz
      for (let quizid in this.quizzes) {
        const val = this.quizzes[quizid]
        if (val && val.link) {
          if (val.link.front === undefined) {
            // firstQuiz = val
            lastQuiz = val
            linkedQuizzes.push(lastQuiz)
          }
        }
      }

      if (lastQuiz && lastQuiz.link) {
        l.d('EditableQuizzes/linkedQuizzes', lastQuiz)
        while (lastQuiz.link.rear) {
          if (lastQuiz.link && lastQuiz.link.rear) {
            lastQuiz = this.quizzes[lastQuiz.link.rear]
            linkedQuizzes.push(lastQuiz)
          }
        }
      }
      return linkedQuizzes
    }
  },
  computed: {
    ...mapState('quizbank', ['quizbank']),
    ...mapGetters('quizbank', [
      'quizzes',
      'quizDate'
    ])
  },
  components: {
    EditableQuiz,
    QuizzesItem,
    draggable
  }
}
</script>

<style scoped>

</style>
